import type { ReactNode } from 'react';
import { Badge } from '@/shared/ui/core';
import { cn } from '@/shared/lib/cn';

export type PageHeaderProps = {
  title: string;
  subtitle?: string;
  screenId?: string;
  actions?: ReactNode;
  meta?: ReactNode;
  tabs?: ReactNode;
  className?: string;
};

export function PageHeader({
  title,
  subtitle,
  screenId,
  actions,
  meta,
  tabs,
  className,
}: PageHeaderProps) {
  return (
    <header className={cn('mb-3 space-y-2', className)}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <h1 className="text-page-title m-0 truncate">{title}</h1>
            {screenId ? <Badge tone="neutral" label={screenId} /> : null}
          </div>
          {subtitle ? (
            <p className="mt-1 mb-0 text-body text-text-secondary">{subtitle}</p>
          ) : null}
          {meta}
        </div>
        {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
      </div>
      {tabs}
    </header>
  );
}
